let btn1 = document.getElementById("step-1")
let btn2 = document.getElementById("step-2")
let btn3 = document.getElementById("step-3")
let btn4 = document.getElementById("step-4")

let btnNextStep1 = document.getElementById("step-next-1")
let btnNextStep2 = document.getElementById("step-next-2")
let btnNextStep3 = document.getElementById("step-next-3")
let btnNextStep4 = document.getElementById("step-next-4")

let btnPrevStep1 = document.getElementById("step-prev-1")
let btnPrevStep2 = document.getElementById("step-prev-2")
let btnPrevStep3 = document.getElementById("step-prev-3")
let btnPrevStep4 = document.getElementById("step-prev-4")

let wrapper1 = document.getElementById("wrapper-1")
let wrapper2 = document.getElementById("wrapper-2")
let wrapper3 = document.getElementById("wrapper-3")
let wrapper4 = document.getElementById("wrapper-4")

let title1 = document.getElementById("step-title-1")
let title2 = document.getElementById("step-title-2")
let title3 = document.getElementById("step-title-3")
let title4 = document.getElementById("step-title-4")

let text1 = document.getElementById("step-text-1")
let text2 = document.getElementById("step-text-2")
let text3 = document.getElementById("step-text-3")
let text4 = document.getElementById("step-text-4")

let currentStep = 1

if (btn1 != null && btn2 != null && btn3 != null && btn4 != null && btnNextStep1 != null && btnPrevStep1 != null) {
    btn1.addEventListener("click", function () {
        currentStep = 1
        setContent(currentStep)
    });

    btn2.addEventListener("click", function () {
        currentStep = 2
        setContent(currentStep)
    });

    btn3.addEventListener("click", function () {
        currentStep = 3
        setContent(currentStep)
    });

    btn4.addEventListener("click", function () {
        currentStep = 4
        setContent(currentStep)
    });

    btnNextStep1.addEventListener("click", function () {
        if (currentStep < 4) {
            currentStep += 1
            setContent(currentStep)
        } else if (currentStep === 4) {
            currentStep = 1
            setContent(currentStep)
        }
    });
    btnNextStep2.addEventListener("click", function () {
        if (currentStep < 4) {
            currentStep += 1
            setContent(currentStep)
        } else if (currentStep === 4) {
            currentStep = 1
            setContent(currentStep)
        }
    });
    btnNextStep3.addEventListener("click", function () {
        if (currentStep < 4) {
            currentStep += 1
            setContent(currentStep)
        } else if (currentStep === 4) {
            currentStep = 1
            setContent(currentStep)
        }
    });
    btnNextStep4.addEventListener("click", function () {
        if (currentStep < 4) {
            currentStep += 1
            setContent(currentStep)
        } else if (currentStep === 4) {
            currentStep = 1
            setContent(currentStep)
        }
    });

    btnPrevStep1.addEventListener("click", function () {
        if (currentStep > 1) {
            currentStep -= 1
            setContent(currentStep)
        } else if (currentStep === 1) {
            currentStep = 4
            setContent(currentStep)
        }
    });
    btnPrevStep2.addEventListener("click", function () {
        if (currentStep > 1) {
            currentStep -= 1
            setContent(currentStep)
        } else if (currentStep === 1) {
            currentStep = 4
            setContent(currentStep)
        }
    });
    btnPrevStep3.addEventListener("click", function () {
        if (currentStep > 1) {
            currentStep -= 1
            setContent(currentStep)
        } else if (currentStep === 1) {
            currentStep = 4
            setContent(currentStep)
        }
    });
    btnPrevStep4.addEventListener("click", function () {
        if (currentStep > 1) {
            currentStep -= 1
            setContent(currentStep)
        } else if (currentStep === 1) {
            currentStep = 4
            setContent(currentStep)
        }
    });
}

function resetAll() {
    btn1.classList.remove("active")
    wrapper1.classList.remove("active")
    title1.classList.remove("active")
    text1.classList.remove("active")

    btn2.classList.remove("active")
    wrapper2.classList.remove("active")
    title2.classList.remove("active")
    text2.classList.remove("active")

    btn3.classList.remove("active")
    wrapper3.classList.remove("active")
    title3.classList.remove("active")
    text3.classList.remove("active")

    btn4.classList.remove("active")
    wrapper4.classList.remove("active")
    title4.classList.remove("active")
    text4.classList.remove("active")
}

function setContent(step) {
    resetAll()
    if (step === 1) {
        btn1.classList.add("active")
        wrapper1.classList.add("active")
        title1.classList.add("active")
        text1.classList.add("active")
    } else if (step === 2) {
        btn2.classList.add("active")
        wrapper2.classList.add("active")
        title2.classList.add("active")
        text2.classList.add("active")
    } else if (step === 3) {
        btn3.classList.add("active")
        wrapper3.classList.add("active")
        title3.classList.add("active")
        text3.classList.add("active")
    } else if (step === 4) {
        btn4.classList.add("active")
        wrapper4.classList.add("active")
        title4.classList.add("active")
        text4.classList.add("active")
    }
}
